@for (eCover of eCoverParts; track eCover; let i = $index) {
    <sew-headline
        class="e-cover-headline"
        level="4"
        translate
        [translateParams]="{
            name: eCover.name,
            itemNumber: eCover.itemNumber,
            id: eCover.id,
        }"
    >
        X_SELLING_DIALOG.E_COVER.PART
    </sew-headline>
    @if (
        (serialNumber && serialNumber.length) ||
        (eCover.eCoverSerialNumber && eCover.eCoverSerialNumber.length)
    ) {
        <sew-radio-group>
            <p>
                {{ 'X_SELLING_DIALOG.E_COVER.HEADLINE' | translate }}.
                {{ 'X_SELLING_DIALOG.E_COVER.DESCRIPTION' | translate }}
            </p>
            <sew-radio>
                <input
                    [checked]="eCover.isPainted"
                    (change)="eCover.isPainted = !eCover.isPainted"
                    [name]="i"
                    type="radio"
                    [id]="i + '1'"
                />
                <label [for]="i + '1'">{{ 'X_SELLING_DIALOG.E_COVER.PAINTED' | translate }}</label>
            </sew-radio>
            <sew-radio>
                <input
                    [checked]="!eCover.isPainted"
                    (change)="eCover.isPainted = !eCover.isPainted"
                    [name]="i"
                    type="radio"
                    [id]="i + '2'"
                />
                <label [for]="i + '2'">{{ 'X_SELLING_DIALOG.E_COVER.NOT_PAINTED' | translate }}</label>
            </sew-radio>
        </sew-radio-group>
    } @else {
        <p>
            {{ 'X_SELLING_DIALOG.E_COVER.PLEASE_ENTER_SERIALNUMBER' | translate }}
        </p>
        <div class="input-row">
            <div class="search-wrapper">
                <sew-search-field
                    [error]="eCover.error || (eCover.eCoverSerialNumber && eCover.eCoverSerialNumber.length)"
                >
                    <input
                        #searchfield
                        (keydown.enter)="onSearch(eCover, searchfield.value)"
                        autocomplete="off"
                    />
                    <div class="error-text">
                        {{ 'X_SELLING_DIALOG.E_COVER.ERROR_MESSAGE' | translate }}
                    </div>
                </sew-search-field>
            </div>
            <sew-button
                class="button-submit-search"
                icon="search"
                [showIconOnly]="false"
                (click)="onSearch(eCover, searchfield.value)"
            >
                <button>{{ 'X_SELLING_DIALOG.E_COVER.SEARCH_BUTTON' | translate }}</button>
            </sew-button>
        </div>
        @if (serialNumberCriteriaExplanation | async; as criteria) {
            <div class="search-criteria">
                @if (criteria.content.length) {
                    <sew-tooltip direction="top" [attr.auto-width]="isMobile ? null : true" class="tooltip">
                        @for (content of criteria.content; track content) {
                            @if (content.type === 'text') {
                                <sew-markdown
                                    [markdown]="content.text | replaceDoubleLinebreak"
                                ></sew-markdown>
                            }
                            @if (content.type === 'image') {
                                <img
                                    class="search-criteria-image"
                                    src="{{ content.src }}"
                                    title="{{ content.title }}"
                                    alt="{{ content.alt }}"
                                />
                            }
                        }
                    </sew-tooltip>
                }
                <sew-ws-richtext>
                    <p>{{ criteria.headline }}</p>
                </sew-ws-richtext>
            </div>
        }
    }
}
